import React, { useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { CompanyContext } from "../../data/company_context_management";

function AddSectionButton() {
  const {
    hiddenSectionsAvailable,
    aboutSectionHidden,
    prProfilesSectionHidden,
    prAgenciesSectionHidden,
    setOpenEditModal,
    company,
  } = useContext(CompanyContext);

  if (!hiddenSectionsAvailable) return null;

  const openModal = (modalName) => {
    setOpenEditModal(modalName);
  };

  return (
    // align="end": the toggle sits at the right end of the name line, so a start-aligned
    // menu grows past the viewport edge at phone widths.
    <Dropdown align="end" className="ms-2 align-self-center" style={{ width: "auto", maxHeight: "2rem" }}>
      {/* outline-secondary + sm on purpose: an owner-only utility on the name line, visibly
          subordinate to the header's public buttons. */}
      <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic" size="sm">
        <i className="fa-solid fa-plus cursor-pointer" />
        &nbsp; Add a section
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {aboutSectionHidden && <Dropdown.Item onClick={() => openModal("MAIN")}>About Us</Dropdown.Item>}

        {company.displayType === "pr_firm" && !company.page_config?.show_brands && (
          <Dropdown.Item onClick={() => openModal("BRANDS")}>Our Brands</Dropdown.Item>
        )}

        {company.displayType === "pr_firm" && !company.page_config?.show_prs && (
          <Dropdown.Item onClick={() => openModal("PR_TEAM")}>Our PR Team</Dropdown.Item>
        )}

        {company.displayType !== "pr_firm" && prProfilesSectionHidden && (
          <Dropdown.Item onClick={() => openModal("PR_PROFILES")}>Our PR Representatives</Dropdown.Item>
        )}

        {company.displayType !== "pr_firm" && prAgenciesSectionHidden && (
          <Dropdown.Item onClick={() => openModal("PR_AGENCIES")}>Our PR Agencies</Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default AddSectionButton;
